import TomSelect from 'tom-select/dist/cjs/tom-select.complete.js';

export class TomSelectComponent {
  constructor() {
    this.instances = new Map();
    this.init();
    this.setupLivewireListeners();
  }

  init() {
    const tomSelects = document.querySelectorAll('[tom-select]');
    tomSelects.forEach(tomSelect => {
        if (tomSelect.tomselect) {
            tomSelect.tomselect.destroy();
        }
        const config = tomSelect.dataset.config;
        if (config) {
            const instance = new TomSelect(tomSelect, JSON.parse(config));
            this.instances.set(tomSelect, instance);
        } else {
            const instance = new TomSelect(tomSelect);
            this.instances.set(tomSelect, instance);
        }
    });
  }

  setupLivewireListeners() {
    Livewire.on('update', () => {
      console.log('update');
      setTimeout(() => {
        this.init();
      }, 100);
    });
  }
}
